<template>
    <div>
        <kgr-kindergarten-holiday-data-provider
            :kindergarten-id="kindergartenId"
            :year="year"
            :callback="onKindergartenHolidaysLoaded"
        >
            <div class="animated fadeIn">
                <kgr-kindergarten-holiday-years-data-provider
                    :kindergarten-id="kindergartenId"
                    :callback="onYearsLoaded"
                >
                    <div class="animated fadeIn">
                        <kgr-form-scaffold
                            :pending="pending"
                            :with-back-button="false"
                            :with-primary-buttons="false"
                            :with-delete-button="false"
                        >
                            <kgr-kindergarten-holiday-form
                                :kindergarten-id="kindergartenId"
                                :kindergarten-holidays="kindergartenHolidays"
                                :year="year"
                                :years="years"
                                :import-years="importYears"
                                :is-creatable="isCreatable"
                                :is-editable="isEditable"
                                :is-deletable="isDeletable"
                                :error="error"
                            />
                        </kgr-form-scaffold>
                    </div>
                </kgr-kindergarten-holiday-years-data-provider>
            </div>
        </kgr-kindergarten-holiday-data-provider>
    </div>
</template>

<script>
import Error from '../../js/model/Error';
import FormScaffold from '../../components/common/form/FormScaffold';
import KindergartenHolidayDataProvider from '../../components/data-provider/KindergartenHolidayDataProvider';
import KindergartenHolidayForm from '../../components/kindergarten/kindergarten-holiday/KindergartenHolidayForm';
import KindergartenHolidayYearsDataProvider from '../../components/data-provider/KindergartenHolidayYearsDataProvider';

export default {
    components: {
        'kgr-form-scaffold': FormScaffold,
        'kgr-kindergarten-holiday-data-provider': KindergartenHolidayDataProvider,
        'kgr-kindergarten-holiday-years-data-provider': KindergartenHolidayYearsDataProvider,
        'kgr-kindergarten-holiday-form': KindergartenHolidayForm,
    },
    props: {
        kindergartenId: {
            type: Number,
            required: true,
        },
        year: {
            type: Number,
            required: true,
        },
        importYears: {
            type: Array,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: true,
        },
        isCreatable: {
            type: Boolean,
            required: true,
        },
        isDeletable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            error: new Error(),
            pending: false,
            kindergartenHolidays: null,
            years: null,
        }
    },
    methods: {
        onKindergartenHolidaysLoaded(kindergartenHolidays) {
            this.kindergartenHolidays = kindergartenHolidays;
        },
        onYearsLoaded(years) {
            this.years = years;
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
